module.exports = __webpack_public_path__ + "img/ff01.de0fea69.svg";